// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"snowflake"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 2C12 4.42683 12 3.10524 12 5M12 22L12 19M14 3C14 3 12.9933 4.00665 12 5M12 5C11.0066 4.00665 10 3 10 3M12 5C12 5.95738 12 9.0264 12 12.0478M14 21L12 19M12 19L10 21M12 19C12 19 12 15.556 12 12.0478M21 14L19 12M19 12L21 10M19 12H22M19 12L12 12.0478M3 14L5 12M5 12L3 10M5 12L2 12M5 12L12 12.0478M16.9497 7.0503L12 12.0478M7.05025 16.9498L12 12.0478M12 12.0478L16.9497 16.9498M12 12.0478L7.05025 7.0503","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SnowflakeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'snowflake',
    ref,
    icon: element,
  },
));

SnowflakeIcon.displayName = 'SnowflakeIcon';

export default SnowflakeIcon;
